var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22.5 25",
    style: {
      enableBackground: "new 0 0 22.5 25"
    },
    xmlSpace: "preserve",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.7,0C6.6,0,3.3,3.3,3.3,7.4s3.3,7.4,7.4,7.4c4.1,0,7.4-3.3,7.4-7.4S14.8,0,10.7,0z M10.7,13.4 c-3.3,0-5.9-2.7-5.9-5.9s2.7-5.9,5.9-5.9c3.3,0,5.9,2.7,5.9,5.9S14,13.4,10.7,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.6,14.8C2,16.4,0,20.4,0,24.2C0,24.6,0.3,25,0.8,25s0.8-0.3,0.8-0.8c0-3.7,2-7,3.9-8.1 c0.4-0.2,0.5-0.7,0.3-1C5.5,14.7,5,14.6,4.6,14.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.4,14.8c-0.4-0.2-0.8-0.1-1,0.3c-0.2,0.4-0.1,0.8,0.3,1c2.5,1.4,4.3,4.8,4.3,8.1c0,0.4,0.3,0.8,0.8,0.8 s0.8-0.3,0.8-0.8C22.5,20.4,20.4,16.4,17.4,14.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.673f32b4b908aebf2a78be26abc81fa7.svg";
export { ForwardRef as ReactComponent };